var map = {
	"./benikula-hike.jpg": 730,
	"./boat-party.jpg": 8996,
	"./explore-from-the-sky.jpg": 8467,
	"./favare-night-trek.jpg": 3091,
	"./guided-meditation.jpg": 1205,
	"./guided-snorkeling.jpg": 5037,
	"./kayak-escape.jpg": 1887,
	"./mud-ritual.jpg": 7245,
	"./rooftop-yoga.jpg": 2690,
	"./satarial-thermal.jpg": 1549,
	"./special-harbor.jpg": 6981,
	"./sup.jpg": 7963,
	"./take-your-time.jpg": 4729,
	"./walk-with-donkeys.jpg": 677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7777;